import { useAuth0 } from '@auth0/auth0-react';

export default function Footer() {
    const {user,isAuthenticated}=useAuth0();    

    return (<>
        <a className='linkFooter' href="/legal/terms">Termene si conditii</a>
        {(isAuthenticated) && <a className='linkFooter' href="/legal/contact">Contact</a>}
    </>)
}